import { render, staticRenderFns } from "./pip-student.vue?vue&type=template&id=50ab0b44&"
import script from "./pip-student.vue?vue&type=script&lang=js&"
export * from "./pip-student.vue?vue&type=script&lang=js&"
import style0 from "./pip-student.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports